import { useApi } from "../../api/hooks/use-api.ts";
import { ApiMethod } from "../../api/types.ts";
import { withArrayPayload, withObjectPayload } from "../../api/payload.ts";

export const useCertificatesApi = () => {
    const { sendProtectedRequest } = useApi();

    // OK: payload is the certificate array. Error: payload is the error object.
    const getCertificates = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=certificates');

        return response.then(withArrayPayload);
    };

    const updateCertificate = async (certificate) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=updateCertificate&id=' + certificate.id, certificate);

        return response.then(withObjectPayload);
    };

    return { getCertificates, updateCertificate };
};
